var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TIMPI",
    transform: "translate(-250.4 -374.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65005",
    "data-name": "Path 65005",
    d: "M325.705,383.327V400.89L297.5,417.295V407.2l19.53-11.357v-7.472l-10.763-6.263,8.676-5.042h.006Z",
    transform: "translate(-20.305 -1.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65006",
    "data-name": "Path 65006",
    d: "M284.306,395.882,265.254,384.8l-6.178,3.593V400.9l-8.676-5.048V383.345l14.854-8.635,27.728,16.13Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65007",
    "data-name": "Path 65007",
    d: "M299.37,425.941l-.006,10.091-10.189,5.925L274.47,433.4V401.05l8.67,5.043v22.267l6.036,3.507Z",
    transform: "translate(-10.377 -11.247)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimpi);
export default __webpack_public_path__ + "static/media/timpi.5dcc8b6db4219ed3e973667bf4e877ed.svg";
export { ForwardRef as ReactComponent };